import React from "react";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";
import { useToasts } from "react-toast-notifications";

function AddImageItem({ setImage }) {
  const { addToast } = useToasts();
  const handleChange = (e) => {
    let image = Array.from(e.target.files);

    if (image.length > 0) {
      setImage(image);
      addToast("Image selected", {
        appearance: "success",
        autoDismiss: true,
      });
    } else {
      addToast("No image selected", {
        appearance: "error",
        autoDismiss: true,
      });
    }
  };
  return (
    <div
      className="w-full flex"
      style={{
        height: "200px",
        border: "2px dotted rgb(194, 216, 234)",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <label htmlFor="image">
        <AddPhotoAlternateIcon
          style={{
            fontSize: "65px",
            color: "rgb(194, 216, 234)",
            cursor: "pointer",
          }}
        />
      </label>
      <input
        type="file"
        id="image"
        style={{ display: "none" }}
        onChange={handleChange}
      />
    </div>
  );
}

export default AddImageItem;
